import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { FulfillmentOrderLineItem } from "@redotech/redo-fulfillment-group-common/fulfillment-order-line-item";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { getExpandedItems } from "../../utils/outbound-labels-utils";
import { StringListCell } from "../cells/string-list-cell";

const catalogEntry = fgColumnEntries["line-item-custom-attributes"];

function formatCustomAttributes(item: FulfillmentOrderLineItem): string {
  return item.customAttributes
    .filter(
      ({ value }) => value !== "" && value !== null && value !== undefined,
    )
    .map(({ key, value }) => `${key}: ${value}`)
    .join(", ");
}

export const LineItemCustomAttributesColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }) => {
    const attributeStrings = Array.from(
      new Set(
        row.items.map(formatCustomAttributes).filter((s) => s.length > 0),
      ),
    );
    if (attributeStrings.length === 0) {
      return null;
    }
    return (
      <StringListCell
        displayName="line item custom attribute"
        strings={attributeStrings}
      />
    );
  },
  width: catalogEntry.defaultWidth,
  alignment: ColumnAlignment.LEFT,
  renderExpandedCell: ({
    row,
    expansionIndex,
  }: {
    row: FulfillmentGroupData;
    expansionIndex: number;
  }) => {
    const item = getExpandedItems(row)?.[expansionIndex];
    return (
      <RedoTableTextCell text={item ? formatCustomAttributes(item) : ""} />
    );
  },
};
